
const template = require('./shareBaseIcon.template');

// match svg based on colon used to prefix icon type
const svgIconPattern = /.*\:.*/i;

class ShareBaseIconController implements ng.IComponentController {
	/**
     * String ID associated with the glyph in the icon font
     */
	public readonly id:string;	
	public get useSvgIcon(){
        return svgIconPattern.test(this.id);
    }
}
export const ShareBaseIconComponent:ng.IComponentOptions = {
    controller: ShareBaseIconController,
    controllerAs: 'vm',
    template,
    bindings: {
        id: '@',
    }    
}



// WEBPACK FOOTER //
// ./src/sharebase/components/shareBaseIcon/shareBaseIcon.component.ts